import produce from 'immer';

export default produce;
